import { ref, getCurrentScope, onScopeDispose } from 'vue';
import { useDefaultGDKErrorHandler, useGDKErrorToast } from './useGDKFetch';
import { ErrorCode } from '@golden/gdk-base';
export function useObservable(obs, defaultValue = null, errorHandler = useDefaultGDKErrorHandler()) {
    const data = ref(defaultValue);
    const subscription = obs.subscribe({
        next: (result) => { data.value = result; },
        error: (error) => {
            console.warn(error);
            if (error.code === ErrorCode.CLIENT_TIMEOUT) {
                try {
                    useGDKErrorToast()(error);
                }
                catch (e) {
                    errorHandler(error);
                }
                return;
            }
            errorHandler(error);
        }
    });
    if (getCurrentScope()) {
        onScopeDispose(() => {
            if (!subscription.closed) {
                subscription.unsubscribe();
            }
        });
    }
    return data;
}
//# sourceMappingURL=useObservable.js.map